import classes from "./index.module.scss";
import { v4 as uuid } from "uuid";
export default function Card({ images, title, list }) {
  return (
    <div className={classes.card}>
      <div className={classes.card__image}>
        <picture>
          <source srcSet={images.webp} type="image/webp" />
          <img src={images.png} alt="University" width={376} height={222} />
        </picture>
      </div>
      <h3 className={classes.card__title}>{title}</h3>
      <ul className={classes.card__list}>
        {list.map((item) => (
          <li key={uuid()} className={classes.card__item}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}
